<template>
  <footer class="footer--overlay">
    <div
      class="footer__top"
      data-overlay-prevent-close="true"
      >
      <a
        aria-label="top"
        class="icon-link"
        href="#overlay-top"
        v-html="svgContent"
        />
    </div>
  </footer>
</template>

<script>
  import { addSvgToEnd } from 'Helpers/embedSVG';

  export default {
    computed: {
      svgContent() {
        return addSvgToEnd("Top", "icon-link__text--list", "icon__arrow--16--stroke.svg", "icon-link__svg--270");
      },
    }
  };
</script>
